<template>
	<div>
		<h3 class="popup-tilte">Értéktárgyak részletes megadása</h3>
		<ValidationObserver ref="form" v-slot="{ invalid }" slim>
			<div class="popup-form form d-grid">
				<div v-for="(valuableType, index) in getMovableTypes.valuables" :key="valuableType.id" class="px-15px">
					<CalcElem
						name="label"
						:options="{
							type: 'label',
							wrapperClass: 'mb-15px text-center',
							className: '',
							innerClass: '',
							label: valuableType.name,
						}"
					/>
					<CalcElem
						name="insurance_value"
						:index="index"
						:options="{
							inputGroup: 'valuables',
							type: 'text',
							unit: 'Ft',
							rules: 'number_space',
							wrapperClass: 'mb-15px',
							className: '',
							label: `Érték`,
							inputmode: 'numeric',
							format: true,
						}"
					/>
				</div>
			</div>
			<div class="sum">
				<span>Összesen:</span>
				<span>{{ getValuableSum | toCurrency }}</span>
			</div>
			<div class="con-1334 navBtn">
				<a class="navBtn-next btn btn-blue" @click="fill()" :disabled="invalid">Tovább</a>
			</div>
		</ValidationObserver>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
	computed: {
		...mapGetters(['getMovableTypes', 'getValuableSum']),
	},
	methods: {
		...mapMutations(['setInputData', 'showPopup']),
		fill() {
			this.$refs.form.validate().then(success => {
				if (success) {
					this.setInputData({
						group: 'real_estate',
						key: 'valuable_value',
						value: this.getValuableSum,
						index: null,
					});
					this.showPopup(null);
				}
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.popup-form {
	grid-template-columns: 1fr 1fr;
	max-width: 700px;

	@media only screen and (max-width: 575px) {
		grid-template-columns: 1fr;
	}
}

.sum {
	max-width: 700px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	font-size: 18px;
	font-weight: 700;
	border-top: 2px solid black;
	padding-top: 15px;
}
</style>
